import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';

@Injectable()
export class NotModifiedInterceptor implements HttpInterceptor {
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        // Если это ответ HTTP и статус 304, изменяем его на 200
        if (event instanceof HttpResponse && event.status === 304) {
          console.log('304 Not Modified обработан как 200 OK для URL:', req.url);
          // Создаем новый ответ с кодом 200, но сохраняем все остальные данные
          return event.clone({
            status: 200,
            statusText: 'OK'
          });
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        // Если это ошибка 304, обрабатываем её как успешный ответ
        if (error.status === 304) {
          console.log('304 Not Modified обработан как 200 OK для URL:', req.url);
          
          // Создаем успешный ответ с теми же данными
          const successResponse = new HttpResponse({
            status: 200,
            statusText: 'OK',
            headers: error.headers,
            url: error.url || undefined,
            body: error.error || null
          });
          
          return of(successResponse);
        }
        return throwError(() => error);
      }),
      tap((event: HttpEvent<any>) => {
        // Логируем все успешные ответы для отладки
        if (event instanceof HttpResponse) {
          console.log(`HTTP ${event.status} ${event.statusText} для ${req.url}`);
        }
      })
    );
  }
}
